import ContactContents from './ContactContents.jsx';

const Contact = () => {
  return (
    <ContactContents />
  );
}

export default Contact;